export default "/assets/logo/Mint-logo.png"